{
  "accountTitle": "اسم الحساب",
  "accountWalletName": "اسم الحساب / المحفظة",
  "approvedBalance": "الرصيد المعتمد",
  "approvedRewards": "المكافآت المعتمدة",
  "availableBalance": "الرصيد المتاح",
  "balance": "الرصيد",
  "bank": "البنك",
  "bnbWallet": "محفظة BNB",
  "buyBnbUsdt": "شراء BNB / USDT",
  "buyBnbUsdtText": "قم بشراء BNB أو USDT مباشرة لتمويل محفظتك.",
  "buyCryptoSubtitle": "اشترِ العملات الرقمية بأمان وموّل محفظة EXALT الخاصة بك.",
  "buyExaltCoin": "شراء عملة EXALT",
  "buyExaltOnPancake": "شراء EXALT على PancakeSwap",
  "connectedWallet": "المحفظة المتصلة",
  "copied": "تم النسخ",
  "copyAddress": "نسخ العنوان",
  "copyContract": "نسخ العقد",
  "copyExaltContract": "نسخ عنوان عقد EXALT",
  "copyFailed": "فشل النسخ",
  "copyIban": "نسخ IBAN",
  "copyNumber": "نسخ الرقم",
  "deposit": "إيداع",
  "depositAddress": "عنوان الإيداع",
  "depositFailed": "فشل الإيداع",
  "depositRequest": "طلب إيداع",
  "depositRequiredFields": "الاسم والحساب/المحفظة والمبلغ مطلوبة",
  "depositSubmittedSuccessfully": "تم إرسال طلب الإيداع بنجاح",
  "estimatedExchangeWalletValue": "القيمة التقديرية لمحفظة المنصة",
  "exaltContractCopied": "تم نسخ عنوان عقد EXALT.",
  "exaltWallet": "محفظة EXALT",
  "fakeSupportReminder": "احذر من موظفي الدعم المزيفين. لن يطلب فريق Exalt Exchange أبدًا كلمة مرورك أو مفاتيحك الخاصة.",
  "loadingWallet": "جارٍ تحميل المحفظة...",
  "lockedBalance": "الرصيد المجمد",
  "pendingRewards": "المكافآت المعلقة",
  "readyTradingWithdrawal": "جاهز للتداول أو السحب",
  "refreshBalance": "تحديث الرصيد",
  "securityAdminApproval": "موافقة الإدارة مطلوبة قبل إضافة الرصيد",
  "securityBackendApproval": "جميع عمليات الإيداع والسحب محمية بموافقة الخادم",
  "securityLicensedGateways": "المدفوعات البنكية والبطاقات تتم عبر بوابات مرخصة فقط",
  "securityNoAutoRelease": "لا يتم إصدار العملات تلقائياً بدون تحقق",
  "securityReminder": "تذكير أمني",
  "securitySystem": "نظام الأمان",
  "securityWalletVerification": "التحقق من عنوان المحفظة مطلوب",
  "sellSwapBack": "بيع / إعادة التبديل",
  "sellSwapBackText": "بدّل عملة EXALT الخاصة بك مرة أخرى إلى BNB أو USDT في أي وقت.",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "step1": "الخطوة 1",
  "step2": "الخطوة 2",
  "step3": "الخطوة 3",
  "submitDeposit": "إرسال الإيداع",
  "submitWithdrawal": "إرسال السحب",
  "swapToExaltText": "بدّل BNB أو USDT الخاص بك إلى EXALT.",
  "totalAssets": "إجمالي الأصول",
  "totalPortfolioValue": "إجمالي قيمة المحفظة",
  "transactionHashReference": "معرّف المعاملة / Transaction Hash",
  "transfer": "تحويل",
  "usdtWallet": "محفظة USDT",
  "useBscReminder": "استخدم دائمًا شبكة BNB Smart Chain (BEP-20).",
  "verifyContractReminder": "تحقق دائمًا من عنوان العقد الرسمي قبل التداول.",
  "waitingAdminApproval": "بانتظار موافقة الإدارة",
  "wallet": "المحفظة",
  "walletAddress": "عنوان المحفظة",
  "walletBankIbanPlaceholder": "عنوان المحفظة / JazzCash / Easypaisa / الحساب البنكي / IBAN",
  "walletNotConnected": "المحفظة غير متصلة",
  "walletStatus": "حالة المحفظة",
  "walletsSubtitle": "إدارة محفظتك الرقمية وعمليات الإيداع والسحب وطلبات الدفع.",
  "walletsTitle": "المحافظ",
  "withdraw": "سحب",
  "withdrawRequiredFields": "المبلغ واسم الحساب ورقم المحفظة/الحساب مطلوبة",
  "withdrawalFailed": "فشل السحب",
  "withdrawalRequest": "طلب سحب",
  "withdrawalSubmittedSuccessfully": "تم إرسال طلب السحب بنجاح",
  "yourName": "اسمك"
}